const PARAGRAPH_LATEST_SINGLE_RECORD = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
     ... on LatestSingle {
      id
      icon
      heading
      color
      type
      uuid
      listing {
        nid
        author
        bodyListing
        categories {
          alias
          color
          name
          weight
        }
        mainstageImage {
          alt
          archived
          title
          type
          url
          mainstage_1280x460
        }
        memberOnly
        pathAlias
        publishedOn
        summaryListing
        title
        ... on Article {
          authors {
            title
            pathAlias
          }
          ctaButtons {
            color
            title
            url
          }
        }
        ... on News {
          ctaButtons {
            color
            title
            url
          }
        }
      }
    }
  }
`;

export default PARAGRAPH_LATEST_SINGLE_RECORD;
